import { IFile } from '@coverflex-tech/hypernova-utils';
import * as DocumentPicker from 'expo-document-picker';
import * as ImagePicker from 'expo-image-picker';

export async function pickImageFromCamera(): Promise<IFile | undefined> {
  try {
    const permission = await ImagePicker.requestCameraPermissionsAsync();
    if (permission.status !== 'granted') {
      return;
    }

    const cameraResult = await ImagePicker.launchCameraAsync({
      quality: 1,
    });

    const file = cameraResult?.assets?.[0];
    if (file) {
      return {
        name: file.fileName ?? '',
        url: file.uri,
        blob: file.file,
        contentType: file.mimeType,
      };
    }
  } catch {
    return;
  }
}

export async function pickImageFromLibrary(): Promise<IFile | undefined> {
  try {
    const libraryResult = await ImagePicker.launchImageLibraryAsync({
      quality: 1,
    });
    const file = libraryResult?.assets?.[0];
    if (file) {
      return {
        name: file.fileName ?? '',
        url: file.uri,
        blob: file.file,
        contentType: file.mimeType,
      };
    }
  } catch {
    return;
  }
}

export async function pickDocumentsFromLibrary(
  acceptedTypes?: string
): Promise<IFile | undefined> {
  try {
    const libraryResult = await DocumentPicker.getDocumentAsync({
      type: acceptedTypes,
    });
    const file = libraryResult?.assets?.[0];
    if (file) {
      return {
        name: file.name ?? '',
        url: file.uri,
        blob: file.file,
        contentType: file.mimeType,
      };
    }
  } catch {
    return;
  }
}
